// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1QNR4","filesListContainer":"PosDisputesFiles_filesListContainer__1MMXW","filesButton":"PosDisputesFiles_filesButton__2sSR-"};